var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage } from 'react-intl';
import { cssClassMap } from '../../../constants/SportCssMap';
import { getRateDisplayValue } from '../../../rendering-commons';
var messages = defineMessages({
    bets_potential_return: {
        id: 'bets.potential_return',
        defaultMessage: 'Потенциальный возврат'
    },
    coupon_coefficient_not_available: {
        id: 'coupon.coefficient_not_available',
        defaultMessage: 'Coefficient not available'
    },
    coupon_stake_amount: {
        id: 'coupon.stake_amount',
        defaultMessage: 'Stake amount'
    },
    coupon_delete: {
        id: 'coupon.delete',
        defaultMessage: 'Удалить'
    },
    coupon_big_bet: {
        id: 'coupon.big_bet',
        defaultMessage: 'Big stake'
    },
    rate_changed: {
        id: 'bet_history.errors.factor_changed',
        defaultMessage: 'Коэффициент изменился!'
    }
});
var renderRate = function (factorChanged, actualValue, value, unavailable) {
    if (factorChanged) {
        var cls = actualValue > value ? 'new-rate-symbol-up' : 'new-rate-symbol-down';
        return (_jsxs("div", __assign({ className: 'rate rate--changed' }, { children: [_jsx("span", { children: getRateDisplayValue(value) }), _jsxs("span", __assign({ className: cls }, { children: [getRateDisplayValue(actualValue), _jsx("span", {})] }))] })));
    }
    if (unavailable) {
        return _jsx("div", __assign({ className: 'rate rate--changed' }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_coefficient_not_available)) }));
    }
    return _jsx("div", __assign({ className: 'rate' }, { children: getRateDisplayValue(value) }));
};
var Event = function (props) {
    var bet = props.bet, active = props.active;
    var match = bet.get('match');
    var rate = bet.get('rate');
    var outcome = bet.get('outcome');
    var factorChanged = bet.get('factorChanged');
    var unavailable = bet.get('unavailable');
    var value = rate.get('value');
    var actualValue = rate.get('actualValue');
    var isLive = bet.get('rate').get('isLive') ? _jsx("span", __assign({ className: 'live' }, { children: "live" })) : '';
    var matchName = match.get('name');
    var cls = "item-inner ".concat(cssClassMap[rate.get('sportId')], " clearfix");
    var rateChangeCls = '';
    if (actualValue) {
        rateChangeCls = actualValue > value ? 'item__message' : 'item__message item__message-up';
    }
    if (match.get('notice')) {
        matchName += '(' + match.get('notice') + ')';
    }
    var headerTitle = matchName === outcome.get('name')
        ? _jsxs("div", __assign({ className: 'title' }, { children: [rate.get('shortName'), " ", isLive] }))
        : _jsxs("div", __assign({ className: 'title' }, { children: [outcome.get('name'), " \u00A0 ", rate.get('shortName'), " ", isLive] }));
    return (_jsxs("div", __assign({ className: cls }, { children: [_jsxs("div", __assign({ className: 'header', onClick: props.onEventClick }, { children: [_jsxs("div", __assign({ className: "header-inner ".concat(active ? 'active' : '') }, { children: [_jsxs("div", __assign({ className: 'header-left' }, { children: [headerTitle, _jsx("div", __assign({ className: 'sub' }, { children: matchName }))] })), renderRate(factorChanged, actualValue, value, unavailable)] })), _jsx("div", __assign({ className: 'delete', onClick: props.close }, { children: _jsx(FormattedMessage, __assign({}, messages.coupon_delete)) }))] })), actualValue &&
                _jsx(FormattedMessage, __assign({}, messages.rate_changed, { children: function (m) { return _jsx("div", __assign({ className: rateChangeCls }, { children: m })); } }))] })));
};
Event.propTypes = {
    active: PropTypes.bool.isRequired,
    close: PropTypes.func.isRequired,
    onEventClick: PropTypes.func.isRequired,
    isBigStake: PropTypes.bool.isRequired,
    bet: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    changeBetAmount: PropTypes.func.isRequired,
    couponAmount: PropTypes.any.isRequired
};
export default Event;



// WEBPACK FOOTER //
// ./src/components/coupon/quickbet/Event.jsx